import { z } from 'zod/v4';
import { maintenancePrioritySchema } from './enums';

// ! 👇 Maps to S/4HANA CDS view I_MaintenanceOrderDEX
export const maintenanceOrderSchema = z.object({
  maintenanceOrder: z.string(), // AUFNR
  maintenanceOrderType: z.string(), // AUART, e.g. ZPM3
  maintenanceOrderDescription: z.string().optional(), // KTEXT
  maintPriority: maintenancePrioritySchema.optional(), // PRIOK
  equipment: z.string().optional(), // EQUNR
  assembly: z.string().optional(), // BAUTL
  functionalLocation: z.string().optional(), // TPLNR
  maintenancePlanningPlant: z.string().optional(), // IWERK
  maintenancePlant: z.string().optional(), // WERKS
  maintenancePlannerGroup: z.string().optional(), // INGPR
  workCenterInternalId: z.string().optional(), // GEWRK
  maintObjectLocAcctAssgmtNmbr: z.string().optional(), // ILOAN
  companyCode: z.string().optional(), // BUKRS
  createdByUser: z.string().optional(), // ERNAM
  creationDate: z.iso.date().optional(), // ERDAT
  lastChangeByUser: z.string().optional(), // AENAM
  maintenanceNotification: z.string().optional(), // QMNUM — back-link to the notification it was created from
});

export type MaintenanceOrder = z.infer<typeof maintenanceOrderSchema>;

const maintenanceOrderWireObjectSchema = z.object({
  MAINTENANCEORDER: z.string(),
  MAINTENANCEORDERTYPE: z.string(),
  MAINTENANCEORDERDESC: z.string().optional(),
  MAINTPRIORITY: z.coerce.number().pipe(maintenancePrioritySchema).optional(),
  EQUIPMENT: z.string().optional(),
  ASSEMBLY: z.string().optional(),
  FUNCTIONALLOCATION: z.string().optional(),
  MAINTENANCEPLANNINGPLANT: z.string().optional(),
  MAINTENANCEPLANT: z.string().optional(),
  MAINTENANCEPLANNERGROUP: z.string().optional(),
  WORKCENTERINTERNALID: z.string().optional(),
  MAINTOBJECTLOCACCTASSGMTNMBR: z.string().optional(),
  COMPANYCODE: z.string().optional(),
  CREATEDBYUSER: z.string().optional(),
  CREATIONDATE: z.iso.date().optional(),
  LASTCHANGEBYUSER: z.string().optional(),
  MAINTENANCENOTIFICATION: z.string().optional(),
});

export const MAINTENANCE_ORDER_WIRE_FIELDS = maintenanceOrderWireObjectSchema.keyof().options;

/** Validates  raw wire shape and eshapes it into MaintenanceOrder. */
export const maintenanceOrderWireSchema = maintenanceOrderWireObjectSchema.transform(
  (raw): MaintenanceOrder => ({
    maintenanceOrder: raw.MAINTENANCEORDER,
    maintenanceOrderType: raw.MAINTENANCEORDERTYPE,
    maintenanceOrderDescription: raw.MAINTENANCEORDERDESC,
    maintPriority: raw.MAINTPRIORITY,
    equipment: raw.EQUIPMENT,
    assembly: raw.ASSEMBLY,
    functionalLocation: raw.FUNCTIONALLOCATION,
    maintenancePlanningPlant: raw.MAINTENANCEPLANNINGPLANT,
    maintenancePlant: raw.MAINTENANCEPLANT,
    maintenancePlannerGroup: raw.MAINTENANCEPLANNERGROUP,
    workCenterInternalId: raw.WORKCENTERINTERNALID,
    maintObjectLocAcctAssgmtNmbr: raw.MAINTOBJECTLOCACCTASSGMTNMBR,
    companyCode: raw.COMPANYCODE,
    createdByUser: raw.CREATEDBYUSER,
    creationDate: raw.CREATIONDATE,
    lastChangeByUser: raw.LASTCHANGEBYUSER,
    maintenanceNotification: raw.MAINTENANCENOTIFICATION,
  }),
);
